var React = require('react');

function LoveFooter (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-2{fill:#01aced;}")),React.createElement("g",{"id":"MAIN","key":1},React.createElement("g",{"id":"footer"},React.createElement("path",{"className":"cls-2","d":"M14.75,7.45l-6.05,6.24c-.39,.4-1.03,.4-1.42,0L1.24,7.45C-.51,5.64-.41,2.63,1.55,.96,3.27-.5,5.82-.24,7.38,1.38l.62,.63,.62-.63c1.57-1.62,4.12-1.88,5.83-.42,1.96,1.67,2.07,4.68,.31,6.5Z"})))]);
}

LoveFooter.defaultProps = {"id":"Layer_2","viewBox":"0 0 16 14"};

module.exports = LoveFooter;

LoveFooter.default = LoveFooter;
